export const heroAgentSocialProofVariants = {
  FORTUNE_500_USAGE: "fortune-500-usage",
  FORTUNE_500_COMPANIES: "fortune-500-companies",
} as const;

export type HeroAgentSocialProofVariant =
  (typeof heroAgentSocialProofVariants)[keyof typeof heroAgentSocialProofVariants];

export interface BlocksMeta {
  pageSlug?: string | null | undefined;
  heroAgentSocialProofVariant?: HeroAgentSocialProofVariant;
}
